.uom-article {
  $root: &;

  background-color: var(--palette-background-secondary);
  color: var(--palette-foreground-primary);
  display: grid;
  gap: 15px;
  grid-template: "picture meta" 1fr / max-content 1fr;
  padding: 20px 15px;
  position: relative;
  text-decoration: none !important;

  @include use-dziub-dziub($color: var(--palette-background-secondary), $slot: after);

  &__meta {
    display: flex;
    flex-flow: column nowrap;
    gap: 10px;
    grid-area: meta;
  }

  &__image {
    background-color: var(--palette-foreground-tertiary);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='%23757575'%3E%3Cpath d='M160-120q-33 0-56.5-23.5T80-200v-640l67 67 66-67 67 67 67-67 66 67 67-67 67 67 66-67 67 67 67-67 66 67 67-67v640q0 33-23.5 56.5T800-120H160Zm0-80h280v-240H160v240Zm360 0h280v-80H520v80Zm0-160h280v-80H520v80ZM160-520h640v-120H160v120Z'/%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    grid-area: picture;
    height: 70px;
    object-fit: cover;
    width: 100px;

    @include use-desktop-device {
      width: 125px;
    }
  }

  &__title {
    -webkit-box-orient: vertical;
    color: var(--palette-foreground-primary);
    display: -webkit-box;
    font: use-font-secondary("700 16px/20px");
    -webkit-line-clamp: 3;
    max-height: 3lh;
    overflow: hidden;
    overflow-wrap: break-word;

    @include use-desktop-device {
      font: use-font-secondary("700 18px/23px");
    }

    #{$root}:hover & {
      text-decoration: underline;
    }

    &[data-title-prefix]::before {
        align-items: center;
        background-color: var(--palette-accent-primary);
        color: var(--palette-accent-primary-contra);
        content: attr(data-title-prefix);
        display: inline-flex;
        font: use-font-secondary("700 14px/1lh");
        height: 20px;
        margin-right: 1ch;
        padding: 0 4px;
        text-transform: uppercase;
        transform: translateY(calc(-0.5 * (1lh - 20px)));
        white-space: nowrap;
    }
  }

  &__business-type {
    color: var(--palette-foreground-secondary);
    font: use-font-accent("300 12px/20px");
    text-transform: uppercase;
  }
}
